import {ReactElement} from "react";
import {Property} from "../../contexts/properties/logic";
import {VersionType} from "../../__generated__/generated_types";
import YearMonthRange from "./YearMonthRange";

export interface YearMonthRangeForPropertyProps {
    property: Property;
    versionType: VersionType.Budget | VersionType.Reforecast;
    className?: string;
}

export function YearMonthRangeForProperty(props: YearMonthRangeForPropertyProps): ReactElement {
    const currentProperty = props.property;
    function renderReforecast(): ReactElement {
        return (currentProperty.isAcquisitionProperty ?
            <YearMonthRange
                    startYear={currentProperty.acquisitionBudgetYear ?? currentProperty.reforecastYear}
                    startMonthIdx={currentProperty.acquisitionBudgetStartMonth}
                    endYear={(currentProperty.acquisitionBudgetYear ?? currentProperty.reforecastYear) + (currentProperty.acquisitionBudgetStartMonth && currentProperty.acquisitionBudgetStartMonth > 0 ? 1 : 0)}
                    endMonthIdx={currentProperty.acquisitionBudgetStartMonth ? currentProperty.acquisitionBudgetStartMonth - 1 : 11}
                    className={props.className}
            /> :
            <YearMonthRange
                    startYear={currentProperty.reforecastYear}
                    startMonthIdx={0}
                    endYear={currentProperty.reforecastYear}
                    endMonthIdx={11}
                    className={props.className}
            />
        );
    }

    function renderBudget(): ReactElement {
        return (currentProperty.isAcquisitionProperty ?
            <YearMonthRange
                    startYear={(currentProperty.acquisitionBudgetYear ?? currentProperty.reforecastYear) + 1}
                    startMonthIdx={currentProperty.acquisitionBudgetStartMonth}
                    endYear={(currentProperty.acquisitionBudgetYear ?? currentProperty.reforecastYear) + (currentProperty.acquisitionBudgetStartMonth && currentProperty.acquisitionBudgetStartMonth > 0 ? 2 : 1)}
                    endMonthIdx={currentProperty.acquisitionBudgetStartMonth ? currentProperty.acquisitionBudgetStartMonth - 1 : 11}
                    className={props.className}
            />:
            <YearMonthRange
                    startYear={currentProperty.budgetYear}
                    startMonthIdx={0}
                    endYear={currentProperty.budgetYear}
                    endMonthIdx={11}
                    className={props.className}
            />
        );
    }

    return (props.versionType === VersionType.Reforecast ? renderReforecast() : renderBudget());
}